module.exports = __webpack_public_path__ + "e090e741e5a0172193839ec517879cab.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/logos/wr-logo-white.png
// module id = 223
// module chunks = 0